"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDropDown = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Dropdown_1 = require("../Dropdown");
var _1 = require("./");
var StyledDropdown = (0, styled_components_1.default)(Dropdown_1.Dropdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.btn.btn-xs i {\n\t\tfont-size: 7px;\n\t}\n\t.btn.btn-sm i {\n\t\tfont-size: 9px;\n\t}\n\t.btn.btn-md i {\n\t\tfont-size: 10px;\n\t}\n\t.btn.btn-lg i {\n\t\tfont-size: 12px;\n\t}\n"], ["\n\t.btn.btn-xs i {\n\t\tfont-size: 7px;\n\t}\n\t.btn.btn-sm i {\n\t\tfont-size: 9px;\n\t}\n\t.btn.btn-md i {\n\t\tfont-size: 10px;\n\t}\n\t.btn.btn-lg i {\n\t\tfont-size: 12px;\n\t}\n"])));
StyledDropdown.displayName = 'StyledDropdown';
var ActionContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tz-index: 2000;\n"], ["\n\tz-index: 2000;\n"])));
ActionContainer.displayName = 'ActionContainer';
var IconContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: 15px;\n\tmargin-right: -10px;\n\ti.tws-i-icon {\n\t\tfont-size: 10px;\n\t}\n"], ["\n\tmargin-left: 15px;\n\tmargin-right: -10px;\n\ti.tws-i-icon {\n\t\tfont-size: 10px;\n\t}\n"])));
IconContainer.displayName = 'IconContainer';
var StyledDropdownMenu = (0, styled_components_1.default)(Dropdown_1.DropdownMenu)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-top: 10px;\n\tmin-width: 325px;\n\twidth: 100%;\n\tleft: ", ";\n\tright: ", ";\n"], ["\n\tmargin-top: 10px;\n\tmin-width: 325px;\n\twidth: 100%;\n\tleft: ", ";\n\tright: ", ";\n"])), function (props) { return (props.align === 'left' ? 0 : 'auto !important'); }, function (props) { return (props.align === 'right' ? '0 !important' : 'auto'); });
StyledDropdownMenu.displayName = 'StyledDropdownMenu';
var ButtonDropDown = /** @class */ (function (_super) {
    __extends(ButtonDropDown, _super);
    function ButtonDropDown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { toggleDropDown: false, x: 0, y: 0 };
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.handleOnScroll = _this.handleOnScroll.bind(_this);
        _this.handleToggleDropDown = _this.handleToggleDropDown.bind(_this);
        window.addEventListener('scroll', _this.handleOnScroll);
        return _this;
    }
    ButtonDropDown.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleOnScroll);
    };
    ButtonDropDown.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledDropdown, null,
                React.createElement(_1.Button, { id: 'tws-dropdown-center', color: this.props.color, size: this.props.size, onClick: this.handleOnClick },
                    this.props.buttonText,
                    React.createElement(IconContainer, { onClick: function () { return null; } },
                        React.createElement(_1.Icon, { name: 'caret-down' }))),
                React.createElement(ActionContainer, { onClick: function () { return _this.handleToggleDropDown(false); } },
                    React.createElement(StyledDropdownMenu, { align: this.props.align, open: this.state.toggleDropDown, x: 0, y: this.getYPos(), onBlur: function () { return _this.handleToggleDropDown(false); } }, this.props.children)))));
    };
    ButtonDropDown.prototype.handleOnClick = function (event) {
        if (event.target.type === 'button') {
            var bounds = event.target.getBoundingClientRect();
            this.handleToggleDropDown(!this.state.toggleDropDown);
            this.setState({ x: bounds.left, y: bounds.bottom - 30 });
        }
        else {
            // handle case when any of the child elements click
            event.target.parentNode.click();
        }
    };
    ButtonDropDown.prototype.handleOnScroll = function () {
        this.handleToggleDropDown(false);
    };
    ButtonDropDown.prototype.handleToggleDropDown = function (setting) {
        this.setState({ toggleDropDown: setting });
    };
    ButtonDropDown.prototype.getYPos = function () {
        switch (this.props.size) {
            default:
                return 30;
            case 'xs':
                return 12;
            case 'sm':
                return 26;
            case 'lg':
                return 36;
        }
    };
    return ButtonDropDown;
}(React.Component));
exports.ButtonDropDown = ButtonDropDown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
